/**
 * Remove slashes from the start and end of a string
 * @param {string} str
 * @return {string}
 */
function stripSlashes(str) {
	return str.replace(/(^\/+|\/+$)/g, '');
}

export default path => {
	[...document.querySelectorAll('a.is-active, a.is-current')].forEach(link => {
		link.classList.remove('is-current');
	});
	[...document.querySelectorAll('a')].forEach(link => {
		if (
			stripSlashes(link.pathname) === stripSlashes(path) ||
			(stripSlashes(link.pathname).length &&
				stripSlashes(path).indexOf(stripSlashes(link.pathname)) >= 0)
		) {
			link.classList.add('is-current');
		}
	});
};
